// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMarkdown-modulemarkdown__PuVLG";
export { _1 as "markdown" }
